import axios from "axios";
import {API_ENDPOINTS} from "../../api/apiEndpoints";
import { apiRequest } from "@/network/apiClient";
import { useFetchExistingFiles } from "../../api/files/useFetchExistingFiles";
import React, { useState } from 'react';
import { toast } from "react-toastify";

const SelectDocuments = ({leadID, handleSendEmailConfirmationCancel, handleSendEmail}) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [showSelectedDocuments, setShowSelectedDocuments] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [fileKey, setFileKey] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [emailStatus, setEmailStatus] = useState(null); // 'success', 'error', or null
    const handleSelection = (fileId, content) => {
        setSelectedFiles(prevSelected => {
            if (prevSelected.includes(fileId)) {
                return prevSelected.filter(id => id !== fileId);
            } else {
                return [...prevSelected, fileId];
            }
        });
        setFileKey(prevKey => {
            if (prevKey.includes(content)) {
                return prevKey.filter(key => key !== content);
            } else {
                return [...prevKey, content];
            }
        });
    }
    const handleFileSelection = () =>{
        setShowSelectedDocuments(true);
    }
    const handleEmailCanclelation = () => {
        setShowSelectedDocuments(false);
    }

    const sendSelectedDocuments = async (e) => {
        setIsLoading(true);
        setEmailStatus(null);
        e.preventDefault();
        // Send to backend API
        try{
            
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_FILES.SEND_TO_COMPLIANCE}/${leadID}`, 'POST', fileKey)
            if(result){
                setEmailStatus('success');
                setTimeout(() => {
                    handleSendEmail();
                }, 2000);// Show success message for 2 seconds before closing
                toast.success('Email sent to compliance. Please check your email')
            } else {
                setEmailStatus('error');
            }
        }catch(error){
            toast.error(error || 'Error sending email');
            setEmailStatus('error');
        } finally {
            setIsLoading(false);
        }
    }

    const handleView = async (key) => {
        const res = await axios.get(`${import.meta.env.VITE_BASE_URL}/preview-file/${encodeURIComponent(key)}`);
        window.open(res.data.url, '_blank', "noopener,noreferrer");
    };

    const {idFileCount,loaFileCount, othersFileCount,idFile,loaFile,othersFile} = useFetchExistingFiles(leadID, refreshTrigger);

    return(
        // Select Documents to be Submitted
        <>
        <div className="fixed z-[60] inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
            <div className="bg-white p-6 rounded-lg w-[70%] scrollable max-h-[80vh] overflow-y-auto relative">
                {/* <span className="flex justify-end"> */}
                    <button
                    onClick={handleSendEmailConfirmationCancel}
                    className="text-xl absolute right-2 top-2 text-gray-500 hover:text-gray-700"
                    >
                        ✕
                    </button>
                {/* </span> */}
                {/* Select Documents to be Submitted */}
                <h1 className="text-2xl font-bold mb-4">Select Documents to be Submitted</h1>
                {/* Letter of Authorization (LOA) */}
                <div className="mb-4">
                    <div className="mt-2 flex flex-col bg-[#E2E8F0] shadow-md rounded-lg ">
                        <h2 className="text-sm font-bold text-start px-4 py-2 border-b border-gray-500">Letter of Authorization (LOA)</h2>
                        <table className="min-w-full bg-white border-b border-gray-200 rounded-lg table-fixed text-sm">
                            <thead key='thead'>
                                <tr key='header-row' className="text-[#94A3B8] bg-[#E2E8F0]">
                                    <th key="header-filename" className="p-4 border-b text-center w-[65%] text-start">File Name</th>
                                    <th key="header-upload-date" className="p-4 border-b text-center w-[15%]">Upload Date</th>
                                    <th key="header-action" className="p-4 border-b text-center w-[15%]">Action</th>
                                    <th key="header-selection" className="p-4 border-b text-center w-[5%]">Selection</th>
                                </tr>
                            </thead>
                            <tbody key='tbody'>
                                {loaFileCount > 0 ? (
                                    loaFile.map((file, index) => (
                                        <tr key={index} className="text-[#1E293B] border-b border-gray-200 text-sm hover:bg-[#F7F7F7]">
                                            <td key={`${index}-filename`} className="p-4 text-start font-bold w-[70%]">{file.filename}</td>
                                            <td key={`${index}-upload-date`} className="p-4 text-center w-[15%]">
                                                {new Date(file.last_modified).toLocaleDateString('en-GB',{
                                                    day: '2-digit',
                                                    month: 'short', 
                                                    year: 'numeric',
                                                })}
                                            </td>
                                            <td key={`${index}-action`} className="p-4 text-center w-[15%]">
                                                <button 
                                                onClick={() => handleView(file.content)}  
                                                className="underline cursor-pointer">
                                                    View Details
                                                </button>
                                            </td>
                                            <td key={`${index}-selection`} className="p-4 text-center w-[5%]">
                                                <input 
                                                    type="checkbox" 
                                                    onChange={() => handleSelection(file.filename, file.content)}
                                                    // checked={selectedFiles.includes(file.id)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ):(
                                    <tr key="no-data-row">
                                        <td key="no-data-cell" colSpan="5" className="text-center py-4 text-gray-500 border-b">
                                        No files found!
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Identification Documents */}
                <div className="mb-4">
                    <div className="mt-2 flex flex-col bg-[#E2E8F0] shadow-md rounded-lg ">
                        <h2 className="text-sm font-bold text-start px-4 py-2 border-b border-gray-500">Identification</h2>
                        <table className="min-w-full bg-white border-b border-gray-200 rounded-lg table-fixed text-sm">
                            <thead key='thead'>
                                <tr key='header-row' className="text-[#94A3B8] bg-[#E2E8F0]">
                                    <th key="header-filename" className="p-4 border-b text-center w-[65%] text-start">File Name</th>
                                    <th key="header-upload-date" className="p-4 border-b text-center w-[15%]">Upload Date</th>
                                    <th key="header-action" className="p-4 border-b text-center w-[15%]">Action</th>
                                    <th key="header-selection" className="p-4 border-b text-center w-[5%]">Selection</th>
                                </tr>
                            </thead>
                            <tbody key='tbody'>
                                {idFileCount > 0 ? (
                                    idFile.map((file, index) => (
                                        <tr key={index} className="text-[#1E293B] border-b border-gray-200 text-sm hover:bg-[#F7F7F7]">
                                            <td key={`${index}-filename`} className="p-4 text-start font-bold w-[70%]">{file.filename}</td>
                                            <td key={`${index}-upload-date`} className="p-4 text-center w-[15%]">
                                                {new Date(file.last_modified).toLocaleDateString('en-GB',{
                                                    day: '2-digit',
                                                    month: 'short', 
                                                    year: 'numeric',
                                                })}
                                            </td>
                                            <td key={`${index}-action`} className="p-4 text-center w-[15%]">
                                                <button 
                                                onClick={() => handleView(file.content)} 
                                                className="underline cursor-pointer">
                                                    View Details
                                                </button>
                                            </td>
                                            <td key={`${index}-selection`} className="p-4 text-center w-[5%]">
                                                <input 
                                                    type="checkbox" 
                                                    onChange={() => handleSelection(file.filename, file.content)}
                                                    // checked={selectedFiles.includes(file.id)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ):(
                                    <tr key="no-data-row">
                                        <td key="no-data-cell" colSpan="5" className="text-center py-4 text-gray-500 border-b">
                                        No files found!
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Other Documents */}
                <div className="mb-4">
                    <div className="mt-2 flex flex-col bg-[#E2E8F0] shadow-md rounded-lg ">
                        <h2 className="text-sm font-bold text-start px-4 py-2 border-b border-gray-500">Other Documents</h2>
                        <table className="min-w-full bg-white border-b border-gray-200 rounded-lg table-fixed text-sm">
                            <thead key='thead'>
                                <tr key='header-row' className="text-[#94A3B8] bg-[#E2E8F0]">
                                    <th key="header-filename" className="p-4 border-b text-center w-[65%] text-start">File Name</th>
                                    <th key="header-upload-date" className="p-4 border-b text-center w-[15%]">Upload Date</th>
                                    <th key="header-action" className="p-4 border-b text-center w-[15%]">Action</th>
                                    <th key="header-selection" className="p-4 border-b text-center w-[5%]">Selection</th>
                                </tr>
                            </thead>
                            <tbody key='tbody'>
                                {othersFileCount > 0 ? (
                                    othersFile.map((file, index) => (
                                        <tr key={index} className="text-[#1E293B] border-b border-gray-200 text-sm hover:bg-[#F7F7F7]">
                                            <td key={`${index}-filename`} className="p-4 text-start font-bold w-[70%]">{file.filename}</td>
                                            <td key={`${index}-upload-date`} className="p-4 text-center w-[15%]">
                                                {new Date(file.last_modified).toLocaleDateString('en-GB',{
                                                    day: '2-digit',
                                                    month: 'short', 
                                                    year: 'numeric',
                                                })}
                                            </td>
                                            <td key={`${index}-action`} className="p-4 text-center w-[15%]">
                                                <button 
                                                onClick={() => handleView(file.content)} 
                                                className="underline cursor-pointer">
                                                    View Details
                                                </button>
                                            </td>
                                            <td key={`${index}-selection`} className="p-4 text-center w-[5%]">
                                                <input 
                                                type="checkbox" 
                                                onChange={() => handleSelection(file.filename, file.content)}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ):(
                                    <tr key="no-data-row">
                                        <td key="no-data-cell" colSpan="5" className="text-center py-4 text-gray-500 border-b">
                                        No files found!
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* Select Contact Details */}

                <div className="w-[30%] gap-6 ml-auto flex flex-row items-center mt-6">
                    <button
                        className={`bg-yellow-300 text-black py-4 w-full rounded-3xl ${selectedFiles.length === 0 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} hover:bg-yellow-400`}
                        onClick={handleFileSelection}
                        disabled={selectedFiles.length === 0}
                    >
                        <b>Confirm & Submit</b>
                    </button>
                    <div className="mt-6 mb-6">
                        <button
                            className="text-black underline hover:text-blue-800 focus:outline-none"
                            onClick={handleSendEmailConfirmationCancel}
                        >
                            <b>No, Don't Submit</b>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        {showSelectedDocuments && (
            <div className="fixed inset-0 z-[70] bg-black bg-opacity-50 flex items-center justify-center text-center">
                <div className="bg-white p-6 rounded-lg w-auto scroll relative">
                    {isLoading && (
                        <div className="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center rounded-lg">
                            <div className="text-center">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
                                <p className="text-lg font-semibold">Sending email...</p>
                                <p className="text-gray-600">Please wait while we process your request</p>
                            </div>
                        </div>
                    )}
                    
                    {emailStatus === 'success' && (
                        <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center rounded-lg">
                            <div className="text-center">
                                <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-green-100 flex items-center justify-center">
                                    <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                                <p className="text-lg font-semibold text-green-600">Email sent successfully!</p>
                                <p className="text-gray-600">The documents have been sent to compliance</p>
                            </div>
                        </div>
                    )}
                    
                    {emailStatus === 'error' && (
                        <div className="absolute inset-0 bg-white bg-opacity-95 flex items-center justify-center rounded-lg">
                            <div className="text-center">
                                <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-red-100 flex items-center justify-center">
                                    <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </div>
                                <p className="text-lg font-semibold text-red-600">Failed to send email</p>
                                <p className="text-gray-600">Please try again or contact support</p>
                                <button
                                    className="mt-4 bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                                    onClick={() => setEmailStatus(null)}
                                >
                                    Try Again
                                </button>
                            </div>
                        </div>
                    )}

                    <h2 className="text-lg font-bold mb-4">Selected Documents</h2>
                    <h2 className="mb-4">{selectedFiles.length} files selected to be send to compliance. Please make sure the following files are correct!</h2>
                    <div className="text-start bold px-2">
                        { selectedFiles.length === 0 ? (
                            <p>No documents selected.</p>
                        ) : (
                            <ul className="list-disc pl-5">
                                {selectedFiles.map((document, index) => (
                                    <li key={index}>{document}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="mt-6 mb-6">
                        <button
                            className="text-black underline hover:text-blue-800 focus:outline-none"
                            onClick={handleEmailCanclelation}
                            disabled={isLoading}
                        >
                            <b>Cancel Submission</b>
                        </button>
                    </div>
                    <button
                        className={`bg-yellow-300 text-black py-4 w-full rounded-3xl ${selectedFiles.length === 0 || isLoading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} hover:bg-yellow-400`}
                        onClick={sendSelectedDocuments}
                        disabled={selectedFiles.length === 0 || isLoading}
                    >
                        <b>{isLoading ? 'Sending...' : 'Send Email'}</b>
                    </button>
                </div>
                
            </div>
        )}
        </>
    )
}

export default SelectDocuments
